import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DocumentSchema, SchemaField } from 'src/app/modules/core/store/models/document.model';
import { FilterGroup } from 'src/app/modules/core/store/models/filters.model';
import { Workflow } from 'src/app/modules/core/store/models/workflow.model';

@Component({
    selector: 'topo-document-filter-dialog',
    templateUrl: './document-filter-dialog.component.html',
    styleUrls: ['./document-filter-dialog.component.scss'],
    standalone: false
})
export class DocumentFilterDialogComponent {
  @Input() isActive: boolean;
  @Input() filterGroup: FilterGroup;
  @Input() schema: DocumentSchema;
  @Input() lookupTargetSchemaFields: SchemaField[];
  @Input() workflow: Workflow;
  @Input() useForDatamart: boolean;
  @Output() cancel = new EventEmitter<void>();
  @Output() filterChanged = new EventEmitter<FilterGroup>();
  saveFilterbuttonDisabled: boolean;
  constructor() {}

  cancelClick(): void {
    this.cancel.emit();
  }

  enableSaveFilterbutton(buttonDisabled) {
    this.saveFilterbuttonDisabled = buttonDisabled;
  }

  ngOnInit(): void {
    this.saveFilterbuttonDisabled = false;
  }

  saveClick(): void {
    this.filterChanged.emit(this.filterGroup);
  }
}
